import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { FaStar } from "react-icons/fa6";

const StatsComponent = () => {
  const stats = [
    { value: 15,  suffix: '+', label: 'Years Experience', info: 'Siv guiding clients since 2010' },
    { value: 300, suffix: '+', label: 'Clients Served',   info: 'Across diverse goals' },
  ];

  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.6 });

  return (
    <div className="grid h-fit" ref={ref}>
      <div
        role="list"
        className="grid lg:grid-cols-2 xl:grid-cols-3 h-fit bg-blue-100 dark:bg-colour5 dark:text-colour1 rounded-3xl border-solid border-colour2 border-[1px] shadow-cardShadow py-6
                   [&_*::before]:content-[''] [&_*::before]:hidden"
      >
        {/* Normal count-up stats */}
        {stats.map((stat, index) => (
          <div role="listitem" key={index} className="grid px-4 py-2 h-full justify-center text-center">
            <div className="grid border-b-2 border-solid border-colour10 pb-4 gap-y-2">
              <h4 className="text-4xl lg:text-3xl font-sans tabular-nums leading-none font-semibold text-colour10">
                {inView ? (
                  <CountUp start={0} end={stat.value} duration={2} suffix={stat.suffix} />
                ) : (
                  '0' + stat.suffix
                )}
              </h4>
              <p className="text-lg lg:text-sm font-semibold font-titleFont">
                {stat.label}
              </p>
              <p className="text-sm text-gray-500 dark:text-colour1">{stat.info}</p>
            </div>
          </div>
        ))}

        {/* Separate stars block */}
        <div role="listitem" className="grid px-4 py-2 h-full text-center justify-center">
          <div className="grid border-b-2 border-solid border-colour10 pb-4 gap-y-2">
            {/* Stars row */}
            <div className="grid grid-flow-col auto-cols-max justify-center text-colour10 text-2xl">
              {[...Array(5)].map((_, i) => <FaStar key={i} />)}
            </div>
            {/* Number + label row */}
            <div className="grid grid-flow-col auto-cols-max text-center justify-center items-baseline gap-x-2">
              <span className="text-4xl lg:text-3xl font-sans tabular-nums font-semibold text-colour10">5</span>
              <span className="text-lg lg:text-sm font-semibold font-titleFont">Star Rating</span>
            </div>
            <p className="text-sm text-gray-500 dark:text-colour1">Client-reviewed excellence</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsComponent;
